import BaseReducer from "../BaseReducer";

export default class RekognitionReducer extends BaseReducer {
  initialState = {

  };
}
